import React, { useState, useCallback } from "react";
import { Helmet } from "react-helmet-async";
import { Switch, Route, withRouter } from "react-router-dom";
import { LoginContext } from "../../../../services/api/authentication-api";
import "./task-page.scss";
// Legacy SCSS imports (the JS components were removed when Triyo.MVC was retired).
// The new TaskCreate / TaskEdit components below still apply the
// `task-create-standard-panel` and `task-edit-standard-panel` className overrides whose
// rules live in these stylesheets, so the imports are kept for the side effect.
import "../task-create-standard-panel/task-create-standard-panel.scss";
import "../task-edit-standard-panel/task-edit-standard-panel.scss";
import TaskCreate from "../task-create-edit/task-create/task-create";
import TaskEdit from "../task-create-edit/task-edit/task-edit";
import TaskForm from "../task-form/task-form";

// Wrapper that owns a resetKey for <TaskCreate>. Bumping the key forces React to
// unmount/remount TaskCreate, which resets all its internal useState values to their
// initial values WITHOUT doing a full window.location.reload(). This replaces the
// previous reload that caused a blank screen in SSO environments on deep URLs.
// See TAD-5697.
const TaskCreateRoute = ({ dateFormatID, privileges }) => {
  const [resetKey, setResetKey] = useState(0);
  const handleCreateAnother = useCallback(() => {
    setResetKey((k) => k + 1);
  }, []);

  return (
    <TaskCreate
      key={resetKey}
      dateFormatID={dateFormatID}
      privileges={privileges}
      onCreateAnother={handleCreateAnother}
    />
  );
};

const TaskPage = (props) => {

  return (
    <div className="task-panel">
      <Helmet>
        <title>Triyo · Task Page</title>
      </Helmet>
      <Switch>
        <Route path="/tasks/:taskId/form/:formId">
          <TaskForm></TaskForm>
        </Route>
        <Route path="/tasks/create/std">
          <TaskCreateRoute
            dateFormatID={props.dateFormatID}
            privileges={props.privileges}
          />
        </Route>
        <Route path="/tasks/edit/std">
          <TaskEdit
            dateFormatID={props.dateFormatID}
            privileges={props.privileges}
          />
        </Route>
        <Route path="/tasks/view/std">
          <TaskEdit
            dateFormatID={props.dateFormatID}
            privileges={props.privileges}
          />
        </Route>
      </Switch>
    </div>
  );
};

TaskPage.contextType = LoginContext;
export default withRouter(TaskPage);
